<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconDraggable_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M6.5 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0M6.5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0M6.5 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0M11.5 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0M11.5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0M11.5 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
    />
</svg>
